import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
    Checkbox,
    FormControlLabel,
    FormGroup,
    LinearProgress,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Fab
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Clear'
import { cropDialogStyles } from '../../../resources/styles/CropDialogStyles'

const BulkDownloadAttachmentsDialog = ({ open, onClose, onDownload, isDownloading }) => {
    const classes = cropDialogStyles()
    const [w9Checked, setW9Checked] = useState(false)
    const [proofInsuranceChecked, setProofInsuranceChecked] = useState(false)

    const getFilter = () => {
        if (w9Checked && proofInsuranceChecked) return 3
        if (w9Checked) return 1
        if (proofInsuranceChecked) return 2
        return 0
    }

    const canDownload = w9Checked || proofInsuranceChecked

    const handleDownload = () => {
        if (onDownload) {
            onDownload(getFilter())
        }
    }

    const handleClose = () => {
        setW9Checked(false)
        setProofInsuranceChecked(false)
        onClose()
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
            <DialogTitle>
                <Typography className={classes.title}>Download Attachments</Typography>
                <Fab
                    size='small'
                    disabled={isDownloading}
                    className={classes.buttonClose}
                    onClick={handleClose}
                >
                    <DeleteIcon className={classes.colorIconClose} />
                </Fab>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 8, paddingBottom: 16 }}>
                <Typography variant='body2' color='textSecondary' style={{ marginBottom: 16 }}>
                    Select the document types you want to download. All matching files from every service provider will
                    be bundled into a single zip file.
                </Typography>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={w9Checked}
                                onChange={(e) => setW9Checked(e.target.checked)}
                                color='primary'
                                disabled={isDownloading}
                            />
                        }
                        label='W9'
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={proofInsuranceChecked}
                                onChange={(e) => setProofInsuranceChecked(e.target.checked)}
                                color='primary'
                                disabled={isDownloading}
                            />
                        }
                        label='Proof of Insurance'
                    />
                </FormGroup>
                {isDownloading && <LinearProgress color='primary' style={{ marginTop: 16 }} />}
            </DialogContent>
            <DialogActions className={classes.actionsButton}>
                <Button onClick={handleClose} disabled={isDownloading}>
                    CANCEL
                </Button>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={handleDownload}
                    disabled={!canDownload || isDownloading}
                >
                    {isDownloading ? 'DOWNLOADING...' : 'DOWNLOAD'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

BulkDownloadAttachmentsDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    isDownloading: PropTypes.bool,
}

BulkDownloadAttachmentsDialog.defaultProps = {
    isDownloading: false,
}

export default BulkDownloadAttachmentsDialog
